module.exports = __webpack_public_path__ + "static/media/yatiios.bac2c75c.jpg";